// Shown when the signed-in user cannot load at all (the server is down, or /api/me failed for a
// reason other than being signed out): the Server error card on its own, with the error reference.
import { useRouteError } from 'react-router';
import { ApiError } from '../auth/api';
import { ServerError } from './SystemStates';

export function LoadError() {
  const error = useRouteError();
  return (
    <div className="lpage">
      <ServerError errorRef={error instanceof ApiError ? error.ref : null} />
    </div>
  );
}
